import React from 'react';
import { useLoading } from '../context/LoadingContext';
import '../styles/message-colors.css';

const LoadingOverlay = () => {
  const { isLoading, loadingMessage, loadingType } = useLoading();

  if (!isLoading) return null;

  // Fonction pour obtenir la classe CSS selon le type
  const getOverlayTypeClass = () => {
    switch (loadingType) {
      case 'error':
        return 'loading-overlay-error';
      case 'warning':
        return 'loading-overlay-warning';
      case 'success':
        return 'loading-overlay-success';
      case 'info':
      default:
        return 'loading-overlay-info';
    }
  };

  // Fonction pour obtenir la couleur du spinner selon le type
  const getSpinnerColorClass = () => {
    switch (loadingType) {
      case 'error':
        return 'loading-spinner-error';
      case 'warning':
        return 'loading-spinner-warning';
      case 'success':
        return 'loading-spinner-success';
      case 'info':
      default:
        return 'loading-spinner-info';
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div className={`bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl ${getOverlayTypeClass()}`}>
        <div className="flex items-center space-x-4">
          {/* Spinner animé */}
          <div className="flex-shrink-0">
            <div className={`animate-spin rounded-full h-8 w-8 border-b-2 ${getSpinnerColorClass()}`}></div>
          </div>
          
          {/* Message */}
          <div className="flex-1">
            <h3 className="text-lg font-medium text-gray-900 mb-1">
              Traitement en cours
            </h3>
            <p className="text-sm text-gray-600">
              {loadingMessage}
            </p>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default LoadingOverlay;
